import logoPayleap from '../assets/logo-payleap.png';
import logoBetterApply from '../assets/logo.png';
import logoMomApply from '../assets/mom-logo.png';
import logoRemoteApply from '../assets/logo-remoteapply.svg';

const BRAND_CONFIGS = {
  payleap: {
    brandName: 'PayLeap',
    brandLogo: logoPayleap,
    brandLogoStyle: 'md:max-w-[130px] max-w-[110px]',
    brandSupportEmail: 'hello@payleap.co',
    brandGA4Id: 'G-3FH6P14H4L',
    brandVwoEnabled: true,
    brandCookieYesId: 'cc69aef18020b20c3c0069591418bac5',
    // Other brands only show the banner on their homepage.
    brandCookieYesAllPages: true,
    // Acquisition is switched off: homepage and free funnel steps redirect to
    // /login (see utils/marketingRedirect.js). Paid steps stay reachable.
    brandMarketingDisabled: true,
  },
  betterapply: {
    brandName: 'BetterApply',
    brandLogo: logoBetterApply,
    brandLogoStyle: 'md:max-w-[150px] max-w-[130px]',
    brandSupportEmail: 'hello@betterapply.co',
    brandGA4Id: 'G-3FH6P14H4L',
    brandVwoEnabled: true,
    brandCookieYesId: '52f117c78c2cd69ac7d04b40df55ceef',
  },
  momapply: {
    brandName: 'MomApply',
    brandLogo: logoMomApply,
    brandLogoStyle: 'md:max-w-[150px] max-w-[130px]',
    brandSupportEmail: 'hello@momapply.com',
    brandGA4Id: 'G-H0YQPMEMR2',
    brandVwoEnabled: true,
    brandCookieYesId: '90f6e29bb7ccf99caa052719217f2d7f',
  },
  remoteapply: {
    brandName: 'RemoteApply',
    brandLogo: logoRemoteApply,
    brandLogoStyle: 'md:max-w-[170px] max-w-[140px]',
    brandSupportEmail: 'hello@remoteapply.co',
    brandGA4Id: 'G-KD2RKTW4GH',
    brandCookieYesId: undefined,
    brandDefaultFunnelNr: '35',
  },
};

/** Production hostnames that load VWO (public/index.html). Includes betterapply.co (not in BRAND_HOSTNAMES). */
export const VWO_PRODUCTION_HOSTNAMES = [
  'payleap.co',
  'www.payleap.co',
  'betterapply.co',
  'www.betterapply.co',
  'momapply.com',
  'www.momapply.com',
];

const BRAND_HOSTNAMES = {
  'payleap.co': 'payleap',
  'www.payleap.co': 'payleap',
  'momapply.com': 'momapply',
  'www.momapply.com': 'momapply',
  'remoteapply.co': 'remoteapply',
  'www.remoteapply.co': 'remoteapply',
  'remoteapply.com': 'remoteapply',
  'www.remoteapply.com': 'remoteapply',
};

// Detect current brand based on domain. Outside production builds the
// REACT_APP_BRAND env var (payleap | betterapply | momapply | remoteapply)
// can force a brand so every brand's funnels can be developed on localhost.
export const getBrand = () => {
  const hostname = window.location.hostname;
  const brandKey = BRAND_HOSTNAMES[hostname];

  if (brandKey) {
    return BRAND_CONFIGS[brandKey];
  }

  const override = process.env.REACT_APP_BRAND;
  if (process.env.NODE_ENV !== 'production' && override && BRAND_CONFIGS[override]) {
    return BRAND_CONFIGS[override];
  }

  return BRAND_CONFIGS.betterapply;
};
